import React, { useState } from 'react';
import { Container } from './styles';
import { ECodeType } from '../../../../../../store/ducks/user/types';
import { Chips } from '@gerdau/hefesto-mais-web/Chips';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';

interface ISearchItemRadioSelectProps {
  disabled: boolean;
  codeType: ECodeType;
  setCodeType(codeType: ECodeType): void;
}
const SearchItemRadioSelect: React.FC<ISearchItemRadioSelectProps> = ({
  disabled,
  codeType,
  setCodeType
}) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { commerceScreenName } = getTaggingInformationScreen(pathname);

  const [selectedChips, setSelectedChips] = useState<string[]>([
    codeType ?? ECodeType.SKU
  ]);

  const handleTagging = (selectedOptionCodeType: ECodeType) => {
    dispatch(
      sendTagging({
        event: 'click',
        screenName: commerceScreenName,
        etapa: 'adicione_produtos_na_lista',
        tipo_de_busca_materiais:
          selectedOptionCodeType === ECodeType.SKU
            ? 'código_de_material_da_gerdau'
            : 'seu_código_interno_de_material'
      })
    );
  };

  const optionsChoice = [
    { id: ECodeType.SKU, label: 'Código de material da Gerdau' },
    { id: ECodeType.CLIENT_SKU, label: 'Seu código interno de material' }
  ];

  return (
    <Container>
      <Chips
        chips={optionsChoice}
        disabled={disabled}
        type="choice"
        selectedChipIds={selectedChips}
        handleSelect={(e) => {
          if (e.length) {
            const [option] = e;
            const selectedOptionCodeType: ECodeType =
              ECodeType[option as ECodeType];
            setCodeType(selectedOptionCodeType);
            setSelectedChips(e);
            handleTagging(selectedOptionCodeType);
            return;
          }
          setSelectedChips([codeType]);
        }}
      />
    </Container>
  );
};

export default SearchItemRadioSelect;
